import { useTheme } from '@cbhq/cds-web/hooks/useTheme';

import { coinbaseRetailThemeId } from '../constants/retailCDSTheme';

/**
 * True when the nearest CDS ThemeProvider renders the Retail theme.
 *
 * Reads only the active theme id, never app state, URL params or experiments,
 * so a package rendered under a host's retail root picks it up and
 * standalone/Storybook consumers keep the default look.
 */
export function useIsRetailTheme(): boolean {
  const theme = useTheme();
  return theme.id === coinbaseRetailThemeId;
}
